<template>
    <!-- Start Header -->
    <Header />
    <!-- End Header -->

    <section data-v-3eb226be="" id="contact_us">
        <div class="container" data-v-3eb226be="">
            <h3 class="fw-bold mb-4 animate__animated animate__backInDown animate__delay-0.1s animate__slow text-center"
                data-v-3eb226be="">تواصل معنا</h3>
            <div id="content_wrapper" class="animate__animated animate__backInUp animate__delay-0.2s animate__slow"
                data-v-3eb226be="">

                <form-wizard @on-complete="onComplete" @on-change="onChange" step-size="xs" color="#233D7C"
                    back-button-text="Back" next-button-text="التالى" :finish-button-text="submitBtn">
                    <tab-content title="غرض التواصل">
                        <div class="row">
                            <div class="col-lg-12 step_1_t mb-1">
                                <span> الخطوة الأولى </span>
                                <h2 class="mb-3"> غرض التواصل </h2>
                                <p> ماهو غرض التواصل؟ </p>
                            </div>
                            <div class="col-lg-12">
                                <div class="middle">
                                    <label>
                                        <input type="radio" name="radio" v-model="type_1" value="company"
                                            v-on:change="TypeChoose" checked />
                                        <div class="male box">
                                            <svg width="50" height="50" viewBox="0 0 72 80" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M67.9351 49.9055C67.6158 49.7211 67.2883 49.5644 66.9552 49.4325C67.5387 46.8136 66.3858 44.0664 63.9657 42.6691L59.3426 40L63.9658 37.3308C66.3863 35.9334 67.5391 33.1858 66.9551 30.5664C67.2894 30.4334 67.6174 30.2778 67.9346 30.0945C70.391 28.6769 71.8327 25.9328 71.6076 23.1038C71.5561 22.4586 70.9896 21.9767 70.3465 22.0286C69.7013 22.08 69.2199 22.6445 69.2711 23.2897C69.3599 24.4048 69.0677 25.4995 68.4838 26.413C66.6088 26.5005 64.8426 25.5494 63.8888 23.8975C62.9351 22.2456 62.9949 20.2402 64.0079 18.6603C65.0911 18.6117 66.1857 18.9064 67.1072 19.5414C67.6404 19.9086 68.3699 19.7742 68.7372 19.2412C69.1044 18.7083 68.9701 17.9786 68.4371 17.6114C66.0996 16.0009 63.0022 15.8766 60.5457 17.2942C60.2279 17.4777 59.9271 17.6822 59.6444 17.9056C57.668 16.092 54.7132 15.7173 52.2938 17.1142L47.6818 19.777L47.6707 19.7834V14.4453C47.6707 11.6508 45.868 9.27891 43.3082 8.47469C43.3605 8.12047 43.3885 7.75828 43.3885 7.38969C43.3885 3.315 40.0735 0 35.9988 0C31.9241 0 28.6091 3.315 28.6091 7.38969C28.6091 7.75828 28.6371 8.12031 28.6894 8.47469C26.1296 9.27891 24.3269 11.6508 24.3269 14.4453V19.7837L19.7038 17.1145C17.2836 15.7172 14.3282 16.0925 12.3518 17.9072C12.0711 17.6847 11.7716 17.4794 11.4524 17.2952C7.92349 15.2578 3.39521 16.4713 1.35771 20C-0.679635 23.5287 0.533803 28.0572 4.06255 30.0945C4.38177 30.2789 4.70974 30.4341 5.04271 30.5658C4.45849 33.1853 5.61115 35.9333 8.03177 37.3308L12.6551 40L8.03177 42.6692C5.61161 44.0664 4.4588 46.8136 5.04224 49.4327C4.70927 49.5644 4.38161 49.7212 4.0624 49.9056C0.534271 51.943 -0.679479 56.4714 1.35771 60C2.7249 62.3681 5.21396 63.6934 7.7699 63.6934C9.02271 63.6934 10.2916 63.375 11.4522 62.7048C11.7718 62.5203 12.0716 62.3148 12.3526 62.0922C13.5183 63.1625 15.0232 63.7337 16.5599 63.7337C17.6282 63.7337 18.7113 63.4586 19.7038 62.8855L24.3269 60.2163V62.8203C24.3269 63.4675 24.8516 63.9922 25.4988 63.9922C26.146 63.9922 26.6707 63.4675 26.6707 62.8203V58.3375V58.0828C26.6707 57.7645 26.8002 57.452 27.0243 57.227L28.8972 55.3541L30.9858 57.4427L29.9654 58.4637C29.7457 58.6834 29.6224 58.9814 29.6224 59.2922V63.4609C29.6224 64.1081 30.1471 64.6328 30.7943 64.6328C31.4415 64.6328 31.9661 64.1081 31.9661 63.4609V61.9344C33.2888 62.1764 34.6396 62.3 35.999 62.3C37.3551 62.3 38.7058 62.1761 40.0318 61.9338V63.4603C40.0318 64.1075 40.5565 64.6322 41.2036 64.6322C41.8508 64.6322 42.3755 64.1075 42.3755 63.4603V59.2916C42.3755 58.9808 42.2521 58.6828 42.0324 58.4631L41.011 57.4414L43.0988 55.3536L44.9727 57.2275C45.2011 57.4559 45.3271 57.7598 45.3271 58.083V65.5542V65.5555C45.3268 67.3042 44.1993 68.7884 42.5982 69.2914C41.3802 66.8795 38.8804 65.2208 35.999 65.2208C33.1186 65.2208 30.6199 66.8781 29.4013 69.2883C28.508 69.0025 27.7304 68.4 27.2361 67.5828C26.9011 67.0291 26.1808 66.8514 25.6269 67.1864C25.0732 67.5213 24.8957 68.2417 25.2305 68.7956C26.0196 70.1006 27.2622 71.0631 28.6904 71.5202C28.6376 71.8761 28.6094 72.24 28.6094 72.6105C28.6094 76.6852 31.9244 80.0002 35.9991 80.0002C40.0738 80.0002 43.3888 76.6852 43.3888 72.6105C43.3888 72.2419 43.3608 71.8798 43.3085 71.5255C45.8683 70.7213 47.671 68.3494 47.671 65.5548V60.2164L52.2941 62.8856C53.2868 63.4587 54.3696 63.7339 55.438 63.7339C56.9744 63.7339 58.4796 63.1625 59.6452 62.0923C59.9261 62.3152 60.226 62.5206 60.5455 62.7052C61.7065 63.3755 62.9749 63.6938 64.2279 63.6938C66.7835 63.6936 69.2729 62.3683 70.6401 60.0003C72.6772 56.4713 71.4638 51.9428 67.9351 49.9055ZM35.9988 67.5644C38.4982 67.5644 40.5779 69.3914 40.9752 71.7797C39.6455 70.567 37.8888 69.8609 35.9988 69.8609C34.109 69.8609 32.3521 70.567 31.0224 71.7797C31.4197 69.3914 33.4994 67.5644 35.9988 67.5644ZM35.9988 77.6562C34.0529 77.6562 32.3619 76.5484 31.5204 74.9309C32.3815 73.2611 34.0896 72.2047 35.9988 72.2047C37.9079 72.2047 39.6161 73.2611 40.4772 74.9309C39.6357 76.5484 37.9447 77.6562 35.9988 77.6562ZM61.0329 19.7989C60.6469 21.5572 60.9138 23.4323 61.8591 25.0695C62.8049 26.7077 64.2974 27.8739 66.0144 28.4184C65.0344 28.7891 63.9661 28.8456 62.9341 28.5691C61.6321 28.2202 60.544 27.385 59.8697 26.217C59.1958 25.05 59.0168 23.6903 59.3657 22.3884C59.6419 21.3578 60.2236 20.4622 61.0329 19.7989ZM58.0613 19.6378C57.6351 20.2884 57.309 21.0088 57.1018 21.7819C56.5907 23.6886 56.853 25.68 57.8401 27.3891C58.8271 29.0989 60.4207 30.322 62.3274 30.8331C62.9641 31.0037 63.6101 31.0881 64.2521 31.0881C64.3905 31.0881 64.5285 31.0823 64.6665 31.0745C65.029 32.7113 64.3071 34.4275 62.7938 35.3013L58.2049 37.9506C57.788 33.3638 55.9757 29.0559 52.9771 25.5409L54.4166 24.7098C54.9771 24.3863 55.1691 23.6695 54.8455 23.1091C54.5219 22.5484 53.8052 22.3566 53.2447 22.6802L49.5174 24.8322C49.2483 24.9875 49.0519 25.2434 48.9715 25.5436L48.6619 26.6978L45.8097 25.9338L46.431 23.615C46.5146 23.3028 46.7147 23.042 46.9946 22.8803L53.4649 19.1447C53.4651 19.1445 53.4652 19.1445 53.4654 19.1444C54.9791 18.2706 56.8252 18.5055 58.0613 19.6378ZM39.474 53.8167C39.7527 53.5378 40.1233 53.3842 40.5177 53.3842C40.8547 53.3842 41.174 53.4972 41.4338 53.7038L39.3611 55.7764C38.9024 55.1975 38.9394 54.3516 39.474 53.8167ZM42.8222 51.8139C42.1622 51.3125 41.3611 51.0405 40.5179 51.0405C40.5177 51.0405 40.5176 51.0405 40.5176 51.0405C40.0532 51.0405 39.6019 51.1237 39.1796 51.2814L35.0299 41.7372L42.9729 38.2864L47.8958 49.6098L42.8222 51.8139ZM33.9432 39.6537C33.1172 40.0136 32.626 40.8291 32.6355 41.6803L23.4238 37.797L26.7876 29.8158L35.3901 33.443L35.3869 33.4444C34.2863 33.9238 33.7799 35.2095 34.2583 36.3108L35.4302 39.0077L33.9432 39.6537ZM45.0577 37.2033C44.8272 36.6686 44.4021 36.2562 43.8605 36.0422C43.3182 35.8277 42.7249 35.838 42.1913 36.0705L37.5801 38.0737L36.4736 35.5277L44.4165 32.0748L49.3376 43.3991L48.0033 43.9786L45.0577 37.2033ZM46.2269 30.0822C45.846 29.9802 45.5276 29.7359 45.3304 29.3944C45.1332 29.0528 45.0807 28.655 45.1829 28.2742L45.2033 28.1975L48.0551 28.9614L48.0344 29.0386C47.8238 29.8244 47.0124 30.2928 46.2269 30.0822ZM35.9988 2.34375C37.9447 2.34375 39.6357 3.45156 40.4772 5.06906C39.6161 6.73891 37.908 7.79531 35.9988 7.79531C34.0897 7.79531 32.3815 6.73891 31.5204 5.06906C32.3619 3.45156 34.0529 2.34375 35.9988 2.34375ZM40.9752 8.22031C40.5779 10.6088 38.4982 12.4356 35.9988 12.4356C33.4994 12.4356 31.4197 10.6086 31.0224 8.22031C32.3521 9.43297 34.1088 10.1391 35.9988 10.1391C37.8886 10.1391 39.6455 9.43297 40.9752 8.22031ZM29.3996 10.7088C30.6176 13.1206 33.1174 14.7794 35.9988 14.7794C38.8802 14.7794 41.3801 13.1206 42.598 10.7088C44.1993 11.2117 45.3269 12.6962 45.3269 14.4453V19.7423C42.4168 18.4022 39.231 17.7 35.9988 17.7C32.721 17.7 29.5565 18.4016 26.6707 19.7314V14.4453C26.6707 12.6962 27.7983 11.2119 29.3996 10.7088ZM12.1274 26.2178C10.8768 28.3838 8.25193 29.2711 5.9838 28.4181C7.70052 27.8734 9.19286 26.7073 10.1383 25.0695C11.0833 23.4328 11.3502 21.5584 10.9649 19.8005C12.8347 21.3388 13.3771 24.0533 12.1274 26.2178ZM3.38755 21.1719C4.32115 19.5548 6.02068 18.6498 7.76599 18.6498C7.83974 18.6498 7.91365 18.6536 7.98755 18.6569C9.00271 20.2373 9.06318 22.2445 8.1088 23.8977C7.15349 25.5523 5.38286 26.5034 3.50458 26.4128C3.23021 25.9823 3.01958 25.5081 2.88365 25.0008C2.53458 23.6989 2.71365 22.3391 3.38755 21.1719ZM3.38755 58.8281C2.71365 57.6609 2.53474 56.3011 2.88349 54.9992C3.01943 54.4919 3.23005 54.0178 3.50458 53.5872C5.38318 53.4964 7.15365 54.4478 8.1088 56.1023C9.06333 57.7556 9.00271 59.7633 7.98708 61.3438C6.16552 61.4238 4.36052 60.5133 3.38755 58.8281ZM10.9651 60.1995C11.3504 58.4416 11.0835 56.5672 10.1385 54.9305C9.19396 53.2945 7.70505 52.1266 5.99099 51.5809C6.5638 51.3664 7.15865 51.2602 7.74896 51.2602C9.49411 51.2602 11.1938 52.1653 12.1274 53.7822C13.3771 55.9467 12.8347 58.6613 10.9651 60.1995ZM18.5318 60.8558C17.0171 61.7303 15.1688 61.4942 13.9326 60.3591C15.4113 58.0984 15.5974 55.1052 14.1571 52.6103C12.7163 50.115 10.0299 48.7794 7.33208 48.9305C6.96708 47.2923 7.68896 45.5734 9.20365 44.6989L9.20411 44.6986L15.6746 40.963C15.9544 40.8014 16.2805 40.7584 16.5926 40.842L18.9108 41.4631L18.1468 44.3153L16.9926 44.0063C16.6927 43.9259 16.3727 43.968 16.1035 44.1234L12.661 46.1109C12.1005 46.4345 11.9085 47.1513 12.2321 47.7117C12.4491 48.0877 12.843 48.2978 13.248 48.2978C13.4468 48.2978 13.6483 48.2472 13.8329 48.1406L14.9855 47.4752C16.5216 51.773 19.3935 55.555 23.1224 58.2052L18.5318 60.8558ZM21.2519 42.0906C21.6329 42.1927 21.9511 42.437 22.1483 42.7786C22.3455 43.1202 22.3979 43.518 22.2957 43.8988C22.0849 44.6847 21.2736 45.1527 20.4882 44.9423L20.411 44.9217L21.1749 42.07L21.2519 42.0906ZM32.6352 55.7775L30.5619 53.7042C30.8219 53.4973 31.1418 53.3844 31.4801 53.3844C31.8752 53.3844 32.2452 53.5373 32.5233 53.8163C32.8022 54.0952 32.956 54.4659 32.956 54.8602C32.9558 55.1977 32.8426 55.5172 32.6352 55.7775ZM32.1583 59.5848L34.1805 57.5614C34.9022 56.8398 35.2996 55.8805 35.2996 54.8602C35.2996 53.8398 34.9021 52.8805 34.1818 52.1602C33.4621 51.4383 32.5026 51.0406 31.4801 51.0406C30.4586 51.0406 29.4991 51.4378 28.778 52.1589L25.3655 55.5714C25.1043 55.8336 24.888 56.1358 24.721 56.4627C21.1988 54.0384 18.5007 50.4977 17.1149 46.4655L19.8819 47.2064C21.9158 47.7509 24.0141 46.5395 24.5596 44.5059C24.8238 43.5203 24.6885 42.4908 24.1783 41.6069C23.6682 40.7231 22.8444 40.0908 21.8586 39.8267L17.1993 38.5783C16.8369 38.4811 16.4685 38.4444 16.1043 38.462C16.3316 35.5158 17.2072 32.6481 18.6747 30.0894C18.9968 29.528 18.8027 28.8117 18.2413 28.4898C17.6797 28.168 16.9638 28.3619 16.6418 28.9233C15.0558 31.6886 14.0874 34.7753 13.7949 37.9517L9.20396 35.3011C7.68943 34.4267 6.96755 32.7081 7.33224 31.07C7.4699 31.0777 7.60771 31.0831 7.74521 31.0831C10.3008 31.0831 12.7902 29.7577 14.1574 27.3897C15.5977 24.8948 15.4116 21.9016 13.9329 19.6409C15.1691 18.5058 17.0172 18.2697 18.5321 19.1442L23.1157 21.7905C22.0443 22.5522 21.0316 23.4139 20.0899 24.3722C19.6363 24.8337 19.6427 25.5758 20.1043 26.0294C20.3324 26.2536 20.6291 26.3655 20.9255 26.3655C21.2288 26.3655 21.5319 26.2484 21.7615 26.015C25.5458 22.1642 30.6022 20.0436 35.9991 20.0436C38.9927 20.0436 41.9404 20.7177 44.6161 21.9992C44.418 22.3064 44.2651 22.6447 44.1676 23.008L42.9191 27.6673C42.6999 28.4852 42.7569 29.333 43.0738 30.1028L38.3615 32.1519L27.5457 27.5914C26.4388 27.1259 25.1594 27.6466 24.6926 28.7523L21.2002 37.0389C20.7352 38.1439 21.2551 39.4233 22.361 39.892L33.7619 44.6981L37.2924 52.8183C36.3583 54.2942 36.5313 56.2748 37.8165 57.5605L39.8391 59.5837C37.3116 60.0748 34.6711 60.0736 32.1583 59.5848ZM44.6394 53.5797L48.9824 51.6931C50.0841 51.2133 50.5904 49.927 50.111 48.8266L48.9379 46.1281L50.4219 45.4834C50.956 45.2523 51.368 44.8267 51.5818 44.2848C51.7957 43.7428 51.7854 43.1503 51.5532 42.6173L47.1294 32.4375C48.6043 32.232 49.889 31.1717 50.2982 29.6455L51.0391 26.8823C54.2166 30.5208 55.9551 35.1369 55.9551 40C55.9551 46.5927 52.6665 52.7602 47.2783 56.4611C47.1115 56.1366 46.8952 55.8356 46.6297 55.5702L44.6394 53.5797ZM53.4658 60.8558L48.8758 58.2058C54.1802 54.4452 57.601 48.5195 58.2018 42.0478L62.7938 44.6991C64.3085 45.5736 65.0304 47.2925 64.6654 48.9306C61.9677 48.7795 59.2811 50.115 57.8404 52.6103C56.4001 55.1052 56.5861 58.0984 58.0649 60.3591C56.8288 61.4942 54.9805 61.7303 53.4658 60.8558ZM59.8702 53.7822C60.8038 52.1652 62.5033 51.2602 64.2486 51.2602C64.8388 51.2602 65.4338 51.3664 66.0066 51.5809C64.2926 52.1264 62.8036 53.2945 61.8591 54.9305C60.9141 56.5672 60.6472 58.4416 61.0326 60.1995C59.1629 58.6613 58.6205 55.9467 59.8702 53.7822ZM68.61 58.8281C67.6371 60.5133 65.8321 61.4238 64.0105 61.3439C62.9949 59.7634 62.9343 57.7558 63.8888 56.1023C64.8441 54.4478 66.6151 53.4966 68.493 53.5872C68.7674 54.0177 68.978 54.4919 69.114 54.9992C69.463 56.3011 69.284 57.6609 68.61 58.8281Z"
                                                    :fill="radio_1" />
                                            </svg>

                                            <span>شراكة</span>
                                        </div>
                                    </label>

                                    <label>
                                        <input type="radio" name="radio" v-model="type_1" value="privilege"
                                            v-on:change="TypeChoose" />
                                        <div class="male box">
                                            <svg width="50" height="50" viewBox="0 0 80 80" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M54.8649 42.7018C54.8649 43.2195 54.4451 43.6393 53.9274 43.6393H26.0723C25.5546 43.6393 25.1348 43.2193 25.1348 42.7017C25.1348 42.184 25.5546 41.7642 26.0723 41.7642H53.9274C54.4451 41.7642 54.8649 42.1842 54.8649 42.7018ZM53.9274 36.1839H26.0723C25.5546 36.1839 25.1348 36.6037 25.1348 37.1214C25.1348 37.639 25.5546 38.0589 26.0723 38.0589H53.9274C54.4451 38.0589 54.8649 37.639 54.8649 37.1214C54.8649 36.6037 54.4451 36.1839 53.9274 36.1839ZM69.7162 46.4725V65.3143C69.7162 65.832 69.2963 66.2518 68.7787 66.2518H61.8248C61.5762 66.2518 61.3377 66.1531 61.162 65.9772C60.986 65.8014 60.8873 65.5629 60.8873 65.3143V63.4568H59.7165C59.1735 63.4568 58.7343 63.5973 58.292 63.9123L57.8427 64.2322C57.9412 65.0439 57.6851 65.9637 57.058 66.835C56.5105 67.5957 55.8327 68.1125 55.1404 68.3503C55.2629 69.1858 55.0221 70.1243 54.4035 70.9837C53.5573 72.1592 52.3755 72.7336 51.292 72.5847C51.0584 73.859 50.1034 75.1134 48.9362 75.6394C48.4896 75.8404 48.0305 75.9215 47.5904 75.8881C47.4993 76.4728 47.248 77.0803 46.833 77.6567C46.0765 78.7079 45.0493 79.2762 44.0666 79.2762C43.5566 79.2762 43.0587 79.1233 42.6166 78.8051L39.5777 76.6201L37.5573 78.6406C37.0657 79.1322 36.441 79.3731 35.7773 79.3731C34.9191 79.3731 33.9962 78.9704 33.2115 78.1862C32.7076 77.6826 32.3635 77.1217 32.1798 76.5575C31.9805 76.6061 31.7754 76.6329 31.5654 76.6331C30.707 76.6331 29.7835 76.2301 28.9988 75.4453C28.5185 74.965 28.1848 74.4325 27.9954 73.8948C27.7527 73.9695 27.4988 74.0079 27.2385 74.0079C26.3801 74.0079 25.4566 73.605 24.672 72.8203C23.9073 72.0556 23.5074 71.1592 23.4876 70.3195C22.7546 70.2061 22.0005 69.8154 21.3432 69.1579C19.9635 67.7781 19.7871 65.9515 20.9237 64.815L21.7799 63.9587L21.7127 63.9109C21.2707 63.5965 20.832 63.4565 20.2899 63.4565H19.1121V65.314C19.1121 65.8317 18.6923 66.2515 18.1746 66.2515H11.2207C10.703 66.2515 10.2832 65.8317 10.2832 65.314V46.4722C10.2832 45.9545 10.703 45.5347 11.2207 45.5347H13.9809L14.0249 1.56278C14.0254 1.04528 14.4449 0.626221 14.9624 0.626221H65.0909C65.6085 0.626221 66.0284 1.04606 66.0284 1.56372C66.0284 15.8823 66.0096 30.4417 65.9915 44.5218L65.9902 45.5347H68.7785C69.2962 45.5347 69.716 45.9545 69.716 46.4722L69.7162 46.4725ZM17.2373 47.41H12.1584V64.3768H17.2373V47.41ZM26.446 66.2451C26.5709 66.12 26.6998 65.9245 26.5918 65.522C26.4115 64.8493 25.6909 64.129 25.0185 63.9489C24.6146 63.8412 24.4199 63.9709 24.2951 64.0958L22.2496 66.1411C21.7466 66.6442 22.3043 67.4675 22.6695 67.8326C23.0927 68.2558 23.9368 68.7547 24.4001 68.2911C24.8634 67.8275 26.446 66.2451 26.446 66.2451ZM32.0549 67.5881C32.1801 67.4628 32.3098 67.2678 32.2016 66.8647C32.0215 66.1918 31.3009 65.4712 30.6282 65.2911C30.5224 65.2626 30.431 65.2508 30.3515 65.2508C30.1274 65.2508 29.997 65.3454 29.9049 65.4378L27.7724 67.5706C27.7724 67.5706 27.7716 67.5714 27.7712 67.5718C27.7707 67.5723 25.5429 69.8003 25.5429 69.8003C25.0882 70.255 25.5659 71.0629 25.998 71.495C26.4302 71.9272 27.238 72.4043 27.6927 71.9503C28.1474 71.4962 32.0551 67.5881 32.0551 67.5881H32.0549ZM34.8005 71.7942L34.8002 71.7939C34.8037 71.7903 34.8076 71.7872 34.8112 71.7837L35.531 71.064C35.6462 70.9489 35.7691 70.7704 35.6948 70.4126C35.6241 70.0723 35.3985 69.6922 35.0755 69.3692C34.6434 68.9373 33.8365 68.4597 33.3813 68.9134C33.381 68.9137 33.3809 68.914 33.3805 68.9142L29.8693 72.4251C29.4146 72.88 29.8924 73.6879 30.3246 74.1198C30.7566 74.5522 31.5641 75.0301 32.0191 74.5753L32.7516 73.8428C32.7527 73.8417 32.7537 73.8404 32.7548 73.8393C32.7559 73.8382 34.8002 71.7942 34.8002 71.7942H34.8005ZM38.4232 74.5461C38.243 73.8734 37.5224 73.1529 36.8499 72.9728C36.4546 72.8668 36.2591 72.9897 36.1338 73.1125L34.0795 75.1668C33.6279 75.6223 34.1051 76.4289 34.5371 76.8604C34.9691 77.2925 35.7774 77.7698 36.2313 77.3153L38.2763 75.27C38.4016 75.1448 38.5313 74.9493 38.4232 74.5461ZM55.7134 64.0058L52.1601 61.4484C52.1516 61.4423 52.1434 61.4361 52.1352 61.4298L45.8535 56.5845C45.2145 56.0918 44.3538 56.0895 43.7121 56.5795L39.9335 59.4659C38.5009 60.5597 36.4702 60.0567 35.1045 58.2689C33.739 56.4812 33.7874 54.3895 35.2199 53.2953L38.4191 50.8515L36.9182 49.6931C36.023 49.0022 35.0441 48.7468 33.9257 48.9133L25.2987 50.1948C25.253 50.2017 25.207 50.205 25.1609 50.205H19.1124V61.5818H20.2902C21.2205 61.5818 22.0415 61.844 22.7998 62.3833L23.1337 62.6208C23.7757 62.08 24.6263 61.9031 25.5035 62.1378C26.6426 62.4426 27.7021 63.3872 28.203 64.4881L28.5788 64.1123C29.2357 63.455 30.1595 63.224 31.1135 63.48C32.4387 63.8348 33.658 65.0543 34.0132 66.3795C34.0571 66.5437 34.0857 66.7068 34.1012 66.8681C34.2624 66.8836 34.4257 66.912 34.5898 66.9559C35.9146 67.3109 37.1337 68.5301 37.4888 69.8551C37.6152 70.3264 37.6223 70.7903 37.5184 71.2184C38.771 71.6317 39.896 72.7973 40.2345 74.0609C40.3063 74.3292 40.3385 74.5948 40.3348 74.8531L43.712 77.2834C44.2343 77.6592 44.9546 77.0576 45.3115 76.5615C45.668 76.0659 46.0095 75.1923 45.4891 74.8161L45.488 74.8153C45.4868 74.8145 45.4859 74.8134 45.4848 74.8126C45.4841 74.8122 45.4835 74.812 45.4829 74.8115L39.3552 70.3356C38.9371 70.0303 38.8457 69.4437 39.1512 69.0256C39.4565 68.6075 40.0429 68.5159 40.4612 68.8215L46.5834 73.2934C46.5834 73.2934 46.5835 73.2934 46.5837 73.2936C46.584 73.2939 46.5845 73.2942 46.5849 73.2945L46.5888 73.2973C46.5888 73.2973 46.5891 73.2976 46.5893 73.2978L47.4285 73.9017C47.5716 74.0048 47.7849 74.1012 48.166 73.9298C48.8007 73.6439 49.3959 72.8168 49.4654 72.1242C49.507 71.7125 49.3506 71.5401 49.208 71.4365L49.2045 71.4339C49.2029 71.4328 49.2015 71.4314 49.1999 71.4303C49.1998 71.4301 49.1995 71.43 49.1991 71.4298L42.1074 66.25C41.6893 65.9447 41.5979 65.3581 41.9034 64.94C42.2087 64.5218 42.7951 64.4301 43.2134 64.7359L50.3035 69.9148L51.2763 70.6145C51.7681 70.969 52.5116 70.4031 52.8821 69.8884C52.9726 69.7628 53.7429 68.6442 52.9471 68.0712C52.9462 68.0704 52.9452 68.0697 52.9441 68.0689C52.9434 68.0683 52.9424 68.0679 52.9416 68.0673L45.6302 62.7267C45.2121 62.4214 45.1207 61.8348 45.4262 61.4167C45.7315 60.9984 46.3179 60.907 46.7362 61.2126L54.0404 66.5479C54.0404 66.5479 54.0418 66.5487 54.0424 66.5493C54.4016 66.8075 55.1049 66.339 55.5363 65.7395C55.8416 65.3153 56.2715 64.4072 55.7135 64.0054L55.7134 64.0058ZM60.8874 50.205H54.8388C54.7926 50.205 54.7465 50.2017 54.7007 50.1948L46.031 48.9039C44.9202 48.7383 43.9455 48.9895 43.0529 49.6714L40.5287 51.5995C40.5287 51.5995 40.528 51.6001 40.5276 51.6004L36.3579 54.7854C35.6373 55.3356 36.1045 56.4895 36.5943 57.1308C37.0841 57.772 38.074 58.5262 38.7952 57.9758L42.5738 55.0893C43.8996 54.077 45.6774 54.0812 46.9984 55.0998L53.2679 59.9356L56.8085 62.4839C56.8512 62.5147 56.8891 62.5486 56.9291 62.5811L57.2041 62.3853C57.9629 61.8447 58.7848 61.5818 59.7163 61.5818H60.8871V50.205H60.8874ZM61.8251 45.535H64.1155L64.1168 44.5197C64.1346 30.7468 64.1529 16.5168 64.1537 2.50153H15.8991L15.856 45.535H18.1748C18.6924 45.535 19.1123 45.9548 19.1123 46.4725V48.33H25.0915L33.6499 47.0586C35.2768 46.8165 36.7616 47.2037 38.0637 48.2086L39.9615 49.6733L41.9148 48.1812C43.2131 47.1892 44.6907 46.8083 46.3071 47.0492L54.9082 48.3298H60.8874V46.4723C60.8874 45.9547 61.3073 45.5348 61.8249 45.5348L61.8251 45.535ZM67.8413 47.41H62.7626V64.3768H67.8413V47.41ZM27.3432 32.0217V28.6865C27.3432 28.1689 27.763 27.749 28.2807 27.749H28.594V18.109C27.8257 17.4018 27.3434 16.3887 27.3432 15.2647C27.3432 15.1531 27.363 15.0425 27.402 14.9379L30.1593 7.51622C30.2957 7.14888 30.6462 6.90528 31.038 6.90528H48.9618C49.3537 6.90528 49.7041 7.14903 49.8405 7.51622L52.5979 14.9378C52.6368 15.0423 52.6566 15.1531 52.6566 15.2645C52.6566 16.3886 52.1741 17.4018 51.4059 18.109V27.7489H51.7191C52.2368 27.7489 52.6566 28.1687 52.6566 28.6864V32.0215C52.6566 32.5392 52.2368 32.959 51.7191 32.959H28.2805C27.7629 32.959 27.343 32.5392 27.343 32.0215L27.3432 32.0217ZM29.224 15.4173C29.3024 16.4447 30.1635 17.2567 31.2105 17.2567C32.3091 17.2567 33.2029 16.3629 33.2029 15.2645C33.2029 14.7468 33.6227 14.327 34.1404 14.327C34.658 14.327 35.0779 14.7468 35.0779 15.2645C35.0779 16.3629 35.9716 17.2567 37.0702 17.2567C38.1688 17.2567 39.0624 16.3629 39.0626 15.2643C39.0626 14.7468 39.4824 14.327 40.0001 14.327C40.5177 14.327 40.9376 14.7468 40.9376 15.2645C40.9376 16.3629 41.8313 17.2567 42.9298 17.2567C44.0282 17.2567 44.9221 16.3629 44.9221 15.2645C44.9221 14.7468 45.342 14.327 45.8596 14.327C46.3773 14.327 46.7971 14.7467 46.7971 15.2643C46.7971 16.3629 47.691 17.2567 48.7895 17.2567C49.8366 17.2567 50.6977 16.4448 50.776 15.4175L48.3101 8.78028H31.6901L29.224 15.4173ZM44.7824 21.9029V27.749H49.531V19.0597C49.2909 19.1065 49.043 19.1317 48.7895 19.1317C47.6196 19.1317 46.5695 18.6095 45.8596 17.7861C45.1499 18.6097 44.0996 19.1317 42.9298 19.1317C41.7599 19.1317 40.7098 18.6095 39.9999 17.7861C39.2902 18.6097 38.2401 19.1317 37.0702 19.1317C35.9004 19.1317 34.8501 18.6095 34.1404 17.7862C33.4307 18.6097 32.3804 19.1317 31.2105 19.1317C30.9568 19.1317 30.7091 19.1064 30.469 19.0595V27.7489H35.2176V21.9028C35.2176 20.8992 36.0341 20.0828 37.0376 20.0828H42.9626C43.9662 20.0828 44.7824 20.8993 44.7824 21.9028V21.9029ZM37.0924 21.9579V27.749H42.9074V21.9579H37.0924ZM29.218 31.0842H50.7816V29.624H29.218V31.0842Z"
                                                    :fill="radio_2" />
                                            </svg>

                                            <span>امتياز</span>
                                        </div>
                                    </label>
                                    <label>
                                        <input type="radio" name="radio" v-model="type_1" value="training"
                                            v-on:change="TypeChoose" />
                                        <div class="male box">
                                            <svg width="50" height="50" viewBox="0 0 80 80" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M3.75068 49.875C3.37568 49.25 3.25068 48.625 3.25068 47.875V6.75C3.12568 4.375 5.12568 2.5 7.50068 2.5H72.5007C74.8757 2.5 76.7507 4.375 76.7507 6.75V47.875C76.7507 48.625 76.5007 49.375 76.2507 49.875"
                                                    :stroke="radio_3" stroke-width="2.5" stroke-miterlimit="10"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M30.376 52.125H22.001" :stroke="radio_3" stroke-width="2.5"
                                                    stroke-miterlimit="10" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path d="M58.001 52.125H49.626" :stroke="radio_3" stroke-width="2.5"
                                                    stroke-miterlimit="10" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path
                                                    d="M51.126 37.125C51.126 39.375 49.251 41.125 47.126 41.125H32.876C30.626 41.125 28.876 39.375 28.876 37.25C28.876 33 31.251 30.125 34.876 28.75L40.001 33.75L45.126 28.625C48.751 30 51.126 32.875 51.126 37.125Z"
                                                    :stroke="radio_3" stroke-width="2.5" stroke-miterlimit="10"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                                <path
                                                    d="M40 23.375C42.8305 23.375 45.125 21.0805 45.125 18.25C45.125 15.4195 42.8305 13.125 40 13.125C37.1695 13.125 34.875 15.4195 34.875 18.25C34.875 21.0805 37.1695 23.375 40 23.375Z"
                                                    :stroke="radio_3" stroke-width="2.5" stroke-miterlimit="10" />
                                                <path
                                                    d="M19.5 77.5C21.75 77.5 23.5 75.75 23.5 73.625C23.5 67.5 18.5 64.25 12.375 64.25C6.25 64.25 1.25 67.375 1.25 73.5C1.25 75.75 3.125 77.5 5.25 77.5H19.5Z"
                                                    :stroke="radio_3" stroke-width="2.5" stroke-miterlimit="10" />
                                                <path
                                                    d="M12.375 59.875C15.2055 59.875 17.5 57.5805 17.5 54.75C17.5 51.9195 15.2055 49.625 12.375 49.625C9.54454 49.625 7.25 51.9195 7.25 54.75C7.25 57.5805 9.54454 59.875 12.375 59.875Z"
                                                    :stroke="radio_3" stroke-width="2.5" stroke-miterlimit="10" />
                                                <path
                                                    d="M47.125 77.5C49.375 77.5 51.125 75.75 51.125 73.625C51.125 67.5 46.125 64.25 40 64.25C33.875 64.25 28.875 67.375 28.875 73.625C28.875 75.875 30.75 77.5 32.875 77.5H47.125Z"
                                                    :stroke="radio_3" stroke-width="2.5" stroke-miterlimit="10" />
                                                <path
                                                    d="M40 59.875C42.8305 59.875 45.125 57.5805 45.125 54.75C45.125 51.9195 42.8305 49.625 40 49.625C37.1695 49.625 34.875 51.9195 34.875 54.75C34.875 57.5805 37.1695 59.875 40 59.875Z"
                                                    :stroke="radio_3" stroke-width="2.5" stroke-miterlimit="10" />
                                                <path
                                                    d="M74.75 77.5C77 77.5 78.75 75.75 78.75 73.625C78.75 67.5 73.75 64.25 67.625 64.25C61.5 64.25 56.5 67.375 56.5 73.625C56.5 75.875 58.375 77.5 60.5 77.5H74.75Z"
                                                    :stroke="radio_3" stroke-width="2.5" stroke-miterlimit="10" />
                                                <path
                                                    d="M67.625 59.875C70.4555 59.875 72.75 57.5805 72.75 54.75C72.75 51.9195 70.4555 49.625 67.625 49.625C64.7945 49.625 62.5 51.9195 62.5 54.75C62.5 57.5805 64.7945 59.875 67.625 59.875Z"
                                                    :stroke="radio_3" stroke-width="2.5" stroke-miterlimit="10" />
                                            </svg>

                                            <span>تدريب</span>
                                        </div>
                                    </label>
                                    <label>
                                        <input type="radio" name="radio" v-model="type_1" value="other"
                                            v-on:change="TypeChoose" />
                                        <div class="male box">
                                            <svg width="50" height="50" viewBox="0 0 80 80" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M69.9993 35.8333H49.9993C48.4528 35.8314 46.9702 35.2162 45.8766 34.1227C44.7831 33.0291 44.1679 31.5465 44.166 30V9.99996C44.1679 8.45344 44.7831 6.9708 45.8766 5.87725C46.9702 4.78369 48.4528 4.1685 49.9993 4.16663H69.9993C71.5459 4.1685 73.0285 4.78369 74.1221 5.87725C75.2156 6.9708 75.8308 8.45344 75.8327 9.99996V30C75.8308 31.5465 75.2156 33.0291 74.1221 34.1227C73.0285 35.2162 71.5459 35.8314 69.9993 35.8333ZM49.9993 9.16663C49.7785 9.16705 49.5667 9.25498 49.4106 9.41117C49.2544 9.56736 49.1664 9.77908 49.166 9.99996V30C49.1664 30.2208 49.2544 30.4326 49.4106 30.5887C49.5667 30.7449 49.7785 30.8329 49.9993 30.8333H69.9993C70.2202 30.8329 70.4319 30.7449 70.5881 30.5887C70.7443 30.4326 70.8323 30.2208 70.8327 30V9.99996C70.8323 9.77908 70.7443 9.56736 70.5881 9.41117C70.4319 9.25498 70.2202 9.16705 69.9993 9.16663H49.9993Z"
                                                    :fill="radio_4" />
                                                <path
                                                    d="M59.999 77.4837C59.233 77.4853 58.4743 77.3354 57.7665 77.0427C57.0586 76.7499 56.4157 76.3201 55.8746 75.7779L44.221 64.1243C43.1289 63.0295 42.5156 61.5463 42.5156 59.9999C42.5156 58.4536 43.1289 56.9704 44.221 55.8756L55.8746 44.2219C56.969 43.1292 58.4524 42.5154 59.999 42.5154C61.5455 42.5154 63.0289 43.1292 64.1233 44.2219L75.777 55.8756C76.8697 56.97 77.4835 58.4534 77.4835 59.9999C77.4835 61.5465 76.8697 63.0299 75.777 64.1243L64.1233 75.7779C63.5822 76.3201 62.9393 76.7499 62.2315 77.0427C61.5236 77.3354 60.7649 77.4853 59.999 77.4837ZM59.999 47.513C59.8895 47.5127 59.781 47.5341 59.6799 47.576C59.5788 47.6179 59.4869 47.6795 59.4098 47.7571L47.7561 59.4107C47.6787 59.4881 47.6173 59.5799 47.5754 59.681C47.5335 59.7821 47.512 59.8905 47.512 59.9999C47.512 60.1094 47.5335 60.2177 47.5754 60.3188C47.6173 60.4199 47.6787 60.5118 47.7561 60.5891L59.4098 72.2428C59.4871 72.3202 59.579 72.3816 59.6801 72.4235C59.7812 72.4653 59.8895 72.4869 59.999 72.4869C60.1084 72.4869 60.2167 72.4653 60.3178 72.4235C60.4189 72.3816 60.5108 72.3202 60.5882 72.2428L72.2418 60.5891C72.3192 60.5118 72.3806 60.4199 72.4225 60.3188C72.4644 60.2177 72.4859 60.1094 72.4859 59.9999C72.4859 59.8905 72.4644 59.7821 72.4225 59.681C72.3806 59.5799 72.3192 59.4881 72.2418 59.4107L60.5882 47.7571C60.511 47.6795 60.4191 47.6179 60.318 47.576C60.2169 47.5341 60.1084 47.5127 59.999 47.513Z"
                                                    :fill="radio_4" />
                                                <path
                                                    d="M29.9993 35.8333H9.99935C8.45283 35.8314 6.97019 35.2162 5.87663 34.1227C4.78308 33.0291 4.16789 31.5465 4.16602 30V9.99996C4.16789 8.45344 4.78308 6.9708 5.87663 5.87725C6.97019 4.78369 8.45283 4.1685 9.99935 4.16663H29.9993C31.5459 4.1685 33.0285 4.78369 34.1221 5.87725C35.2156 6.9708 35.8308 8.45344 35.8327 9.99996V30C35.8308 31.5465 35.2156 33.0291 34.1221 34.1227C33.0285 35.2162 31.5459 35.8314 29.9993 35.8333ZM9.99935 9.16663C9.77847 9.16705 9.56675 9.25498 9.41056 9.41117C9.25437 9.56736 9.16644 9.77908 9.16602 9.99996V30C9.16644 30.2208 9.25437 30.4326 9.41056 30.5887C9.56675 30.7449 9.77847 30.8329 9.99935 30.8333H29.9993C30.2202 30.8329 30.4319 30.7449 30.5881 30.5887C30.7443 30.4326 30.8323 30.2208 30.8327 30V9.99996C30.8323 9.77908 30.7443 9.56736 30.5881 9.41117C30.4319 9.25498 30.2202 9.16705 29.9993 9.16663H9.99935Z"
                                                    :fill="radio_4" />
                                                <path
                                                    d="M29.9993 75.8333H9.99935C8.45283 75.8314 6.97019 75.2162 5.87663 74.1227C4.78308 73.0291 4.16789 71.5465 4.16602 70V50C4.16789 48.4534 4.78308 46.9708 5.87663 45.8772C6.97019 44.7837 8.45283 44.1685 9.99935 44.1666H29.9993C31.5459 44.1685 33.0285 44.7837 34.1221 45.8772C35.2156 46.9708 35.8308 48.4534 35.8327 50V70C35.8308 71.5465 35.2156 73.0291 34.1221 74.1227C33.0285 75.2162 31.5459 75.8314 29.9993 75.8333ZM9.99935 49.1666C9.77847 49.167 9.56675 49.255 9.41056 49.4112C9.25437 49.5674 9.16644 49.7791 9.16602 50V70C9.16644 70.2208 9.25437 70.4326 9.41056 70.5887C9.56675 70.7449 9.77847 70.8329 9.99935 70.8333H29.9993C30.2202 70.8329 30.4319 70.7449 30.5881 70.5887C30.7443 70.4326 30.8323 70.2208 30.8327 70V50C30.8323 49.7791 30.7443 49.5674 30.5881 49.4112C30.4319 49.255 30.2202 49.167 29.9993 49.1666H9.99935Z"
                                                    :fill="radio_4" />
                                            </svg>
                                            <span>اخرى</span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <h3 class="h3_rd mt-3">
                                    هل أنت ؟
                                </h3>
                            </div>
                            <div class="col-lg-12 d-flex">
                                <div class="form-check m-3">
                                    <input type="radio" class="form-check-input" id="radio1" v-model="type_2"
                                        name="optradio" value="individual" checked> فرد
                                    <label class="form-check-label" for="radio1"></label>
                                </div>
                                <div class="form-check m-3">
                                    <input type="radio" class="form-check-input" id="radio2" v-model="type_2"
                                        name="optradio" value="institution"> مؤسسة
                                    <label class="form-check-label" for="radio2"></label>
                                </div>
                                <div class="form-check m-3">
                                    <input type="radio" class="form-check-input" id="radio3" v-model="type_2"
                                        name="optradio" value="trainer"> مدرب
                                    <label class="form-check-label" for="radio3"></label>
                                </div>
                                <div class="form-check m-3">
                                    <input type="radio" class="form-check-input" id="radio4" v-model="type_2"
                                        name="optradio" value="school"> مدرسة
                                    <label class="form-check-label" for="radio4"></label>
                                </div>
                                <div class="form-check m-3">
                                    <input type="radio" class="form-check-input" id="radio5" v-model="type_2"
                                        name="optradio" value="other"> اخرى
                                    <label class="form-check-label" for="radio5"></label>
                                </div>
                            </div>

                        </div>
                    </tab-content>
                    <tab-content title="بيانات التواصل">
                        <div class="row">
                            <div class="col-lg-12 step_2_t mb-1">
                                <span> الخطوة الثانية </span>
                                <h2 class="mb-3">بيانات التواصل </h2>
                                <p> البيانات الشخصية </p>
                            </div>
                            <div class="col-lg-12">
                                <div class="mb-3 mt-3">
                                    <label for="name" class="form-label form-labelcd">الاسم *</label>
                                    <input type="text" v-model="name" class="form-control" id="name"
                                        placeholder="نص مؤقت يمكن استبداله" name="name">
                                </div>
                                <div class="mb-3 mt-3">
                                    <label for="phone" class="form-label form-labelcd">الجوال *</label>
                                    <input type="text" v-model="phone" class="form-control" id="phone"
                                        placeholder="نص مؤقت يمكن استبداله" name="phone">
                                </div>
                                <div class="mb-3 mt-3">
                                    <label for="email" class="form-label form-labelcd">الايميل *</label>
                                    <input type="email" v-model="email" class="form-control" id="email"
                                        placeholder="نص مؤقت يمكن استبداله" name="email">
                                </div>
                                <div class="mb-3 mt-3">
                                    <label for="comments" class="form-label form-labelcd">ملاحظات</label>
                                    <textarea type="textarea" v-model="comment" class="form-control textarea_cs"
                                        id="comments" placeholder="نص مؤقت يمكن استبداله" name="comments"></textarea>
                                </div>
                            </div>
                        </div>
                    </tab-content>
                </form-wizard>
                <!-- <form data-v-3eb226be="">
                    <div class="mb-3" data-v-3eb226be=""><label for="exampleInputText" class="form-label"
                            data-v-3eb226be="">الاسم</label><input type="text" class="form-control w-50 shadow-none"
                            id="exampleInputText" data-v-3eb226be=""></div>
                    <div class="mb-3" data-v-3eb226be=""><label for="exampleInputEmail" class="form-label"
                            data-v-3eb226be="">البريد الإلكتروني</label><input type="email"
                            class="form-control w-50 shadow-none" id="exampleInputEmail" data-v-3eb226be=""></div>
                    <div class="row g-3 align-items-center" data-v-3eb226be="">
                        <div class="col-auto" data-v-3eb226be="">
                            <div class="mb-3 form-check" data-v-3eb226be=""><input type="radio" class="form-check-input"
                                    id="flexRadioDefault1" name="role" data-v-3eb226be=""><label
                                    class="form-check-label shadow-none" for="flexRadioDefault1" data-v-3eb226be="">صاحب
                                    مدرسة</label></div>
                        </div>
                        <div class="col-auto" data-v-3eb226be="">
                            <div class="mb-3 form-check" data-v-3eb226be=""><input type="radio" class="form-check-input"
                                    id="flexRadioDefault2" name="role" data-v-3eb226be=""><label
                                    class="form-check-label shadow-none" for="flexRadioDefault2"
                                    data-v-3eb226be="">مدرب</label></div>
                        </div>
                    </div>
                    <div class="mb-3" data-v-3eb226be=""><label class="form-label" for="phone" data-v-3eb226be="">رقم
                            الهاتف</label><input type="tel" class="form-control w-50 shadow-none" id="phone"
                            data-v-3eb226be=""></div>
                    <div class="mb-3" data-v-3eb226be=""><label class="form-label" for="exampleFormControlTextarea"
                            data-v-3eb226be="">رسالتك</label><textarea class="form-control shadow-none"
                            id="exampleFormControlTextarea" data-v-3eb226be=""></textarea></div><button type="submit"
                        class="btn btn-lg" data-v-3eb226be="">إرسال</button>
                </form> -->
                <!-- <div id="img_wrapper" data-v-3eb226be=""><img src="@/assets/img/ContactUs.f9ae9df1.webp" alt=""
                        data-v-3eb226be=""></div> -->
            </div>
        </div>
    </section>

    <!-- Start Footer -->
    <Footer />
    <!-- End Footer -->

</template>

<script>

//local registration
import { FormWizard, TabContent } from 'vue3-form-wizard'
import 'vue3-form-wizard/dist/style.css'
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import axios from 'axios';

export default {
    name: 'ContactUsView',
    components: {
        FormWizard,
        TabContent
    },
    data() {
        return {
            radio_1: "#ffffff",
            radio_2: "#233D7C",
            radio_3: "#233D7C",
            radio_4: "#233D7C",
            type_1: "company",
            type_2: "individual",
            name: "",
            phone: "",
            email: "",
            comment: "",
            submitBtn: "ارسال",
        }
    },
    methods: {
        async onComplete() {

            if (!this.name || !this.phone || !this.email) {
                //alert("Please Fill form Carefully");
                toast("Please Fill form Carefully", {
                        autoClose: 1000,
                    }); // ToastOptions
                return;
            }

            const axios = require('axios');
            const FormData = require('form-data');
            let data = new FormData();
            data.append('name', this.name);
            data.append('email', this.email);
            data.append('phone', this.phone);
            data.append('purpose', this.type_1);
            data.append('are_you', this.type_2);
            data.append('message', this.comment);

            this.submitBtn = 'Please wait....';

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://steamademy.com/apis/contact/',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': 'POST',
                },
                data: data
            };

            axios.request(config)
                .then((response) => {
                    console.log(JSON.stringify(response.data));
                    this.submitBtn = 'ارسال';
                    toast("Your Request is submited successfully!", {
                        autoClose: 1000,
                    }); // ToastOptions

                    this.name= "";
                    this.phone= "";
                    this.email= "";
                    this.comment= "";
                })
                .catch((error) => {
                    console.log(error);
                    this.submitBtn = 'ارسال';
                    toast("Something went Wrong!", {
                        autoClose: 1000,
                    }); // ToastOptions
                });



            // axios.post('http://localhost:3000/entry', { params: { fname: this.fname, lname: this.lname, age: this.age } })
            //     .then(response => this.responseData = response.data)
            //     .catch(error => { });

        },
        onChange() {
            //alert("Next");
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        TypeChoose(event) {
            if (this.type_1 == 'company') {
                this.radio_1 = "#ffffff";
                this.radio_2 = "#233D7C";
                this.radio_3 = "#233D7C";
                this.radio_4 = "#233D7C";
            }
            if (this.type_1 == 'privilege') {
                this.radio_1 = "#233D7C";
                this.radio_2 = "#ffffff";
                this.radio_3 = "#233D7C";
                this.radio_4 = "#233D7C";
            }
            if (this.type_1 == 'training') {
                this.radio_1 = "#233D7C";
                this.radio_2 = "#233D7C";
                this.radio_3 = "#ffffff";
                this.radio_4 = "#233D7C";
            }
            if (this.type_1 == 'other') {
                this.radio_1 = "#233D7C";
                this.radio_2 = "#233D7C";
                this.radio_3 = "#233D7C";
                this.radio_4 = "#ffffff";
            }
        }
    },

    /*data() {
        return {
            demoSteps: [
                {
                    icon: 'mail',
                    name: 'first',
                    title: 'Sample title 1',
                    subtitle: 'Subtitle sample',
                    component: StepOne,
                    completed: false

                },
                {
                    icon: 'report_problem',
                    name: 'second',
                    title: 'Sample title 2',
                    subtitle: 'Subtitle sample',
                    component: StepTwo,
                    completed: false
                }
            ],
            activeStep: 0,
        }
    },
    methods: {
        // Executed when @completed-step event is triggered
        completeStep(payload) {
            this.demoSteps.forEach((step) => {
                if (step.name === payload.name) {
                    step.completed = true;
                }
            })
        },
        // Executed when @active-step event is triggered
        isStepActive(payload) {
            this.demoSteps.forEach((step) => {
                if (step.name === payload.name) {
                    if (step.completed === true) {
                        step.completed = false;
                    }
                }
            })
        },
        // Executed when @stepper-finished event is triggered
        alert(payload) {
            alert('end')
        }
    }*/

}
</script>
<style scoped src="@/assets/css/app.a60e7e5f.css"></style>
<style>
.vue-form-wizard .wizard-card-footer .wizard-footer-right {
    float: left !important;
}

.vue-form-wizard .wizard-card-footer .wizard-footer-left {
    float: left !important;
    padding-left: 10px;
}

.wizard-progress-with-circle {
    display: none;
}

.vue-form-wizard .wizard-nav-pills {
    margin-top: 0;
    position: relative;
    text-align: center;
    display: flow;
    flex-wrap: wrap;
    width: 30%;
}

.wizard-navigation {
    box-sizing: border-box;
    display: flex;
    /* text-align: center; */
    /* display: flow; */
    /* flex-wrap: wrap; */
}

.vue-form-wizard .wizard-tab-content {
    min-height: 400px;
    width: 80%;
    padding: 30px 20px 10px;
}

.vue-form-wizard .wizard-card-footer {
    padding: 0 20px;
    text-align: right;
    display: flex;
    justify-content: left;
}

.stepTitle {
    position: absolute;
    right: 15%;
    top: 0px;
    font-family: "Bahij_TheSansArabic_Bold" !important;
}

.wizard-nav-pills li a {
    position: relative !important;
    display: flow !important;
}

.vue-form-wizard .wizard-nav>li {
    position: relative;
    display: block;
    padding-bottom: 2rem;
}

.step_1_t span {
    font-family: "Bahij_TheSansArabic_Bold" !important;
    font-size: 14px;
    font-weight: 500;
    line-height: 22.89px;
    text-align: right;
    color: #98268C;

}

.step_1_t h2 {
    font-family: "Bahij_TheSansArabic_Bold" !important;
    font-size: 24px;
    font-weight: 500;
    line-height: 39.25px;
    text-align: right;
    color: #212121;
}

.step_1_t p {
    font-family: "Bahij_TheSansArabic_Bold" !important;
    font-size: 18px;
    font-weight: 500;
    line-height: 29.43px;
    text-align: right;
    color: #233D7C;
}

.middle {
    width: 100%;
    text-align: right;
    /* Made by */
}

.middle h1 {
    font-family: "Bahij_TheSansArabic_Bold" !important;
    color: #fff;
}

.middle input[type=radio] {
    display: none;
}

.middle input[type=radio]:checked+.box {
    background-color: #233D7C;
}

.middle input[type=radio]:checked+path {
    fill: #233D7C;
}

.middle input[type=radio]:checked+.box span {
    color: white;
    /*transform: translateY(70px);*/
}

.middle input[type=radio]:checked+.box span:before {
    /*transform: translateY(0px);
    opacity: 1;*/
}

.middle .box {
    width: 160px;
    height: 138px;
    border-radius: 20px;
    background-color: #fff;
    transition: all 250ms ease;
    will-change: transition;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    position: relative;
    font-family: "Bahij_TheSansArabic_Bold" !important;
    font-weight: 900;
    border: 1px solid #c3c3c3;
    margin: 0.5rem;
    padding: 1.5rem;
}

.middle .box:active {
    /*transform: translateY(10px);*/
}

.middle .box span {
    position: absolute;
    transform: translate(0, 60px);
    left: 0;
    right: 0;
    transition: all 300ms ease;
    font-size: 16px;
    user-select: none;
    color: #000000;
}

.middle .box span:before {
    font-size: 1.2em;
    font-family: FontAwesome;
    display: block;
    transform: translateY(-80px);
    opacity: 0;
    transition: all 300ms ease-in-out;
    font-weight: normal;
    color: white;
}

.middle .male span:before {
    /* content: "";*/
}

.middle .female span:before {
    /* content: "";*/
}

.middle p {
    color: #fff;
    font-family: "Inter", sans-serif;
    font-weight: 400;
}

.middle p a {
    text-decoration: underline;
    font-weight: bold;
    color: #fff;
}

.middle p span:after {
    content: "";
    font-family: FontAwesome;
    color: yellow;
}

.h3_rd {
    font-family: "Bahij_TheSansArabic_Bold" !important;
    font-size: 18px;
    font-weight: 500;
    line-height: 29.43px;
    text-align: right;
    color: #233D7C;

}

.form-check-label {
    font-family: "Bahij_TheSansArabic_Bold" !important;
    font-size: 18px;
    font-weight: 500;
    line-height: 29.43px;
    text-align: right;
    color: #233D7C;

}

.step_2_t span {
    font-family: "Bahij_TheSansArabic_Bold" !important;
    font-size: 14px;
    font-weight: 500;
    line-height: 22.89px;
    text-align: right;
    color: #98268C;
}

.step_2_t h2 {
    font-family: "Bahij_TheSansArabic_Bold" !important;
    font-size: 24px;
    font-weight: 500;
    line-height: 39.25px;
    text-align: right;
    color: #212121;
}

.step_2_t p {
    font-family: "Bahij_TheSansArabic_Bold" !important;
    font-size: 18px;
    font-weight: 500;
    line-height: 29.43px;
    text-align: right;
    color: #233D7C;
}

.form-labelcd {
    font-family: "Bahij_TheSansArabic_Bold" !important;
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    text-align: left;
    color: #010B38;
}

.textarea_cs {
    height: 100px;
}
@media only screen and (max-width: 600px) {
    .vue-form-wizard .wizard-nav-pills{
        display: none !important;
    }
    .vue-form-wizard .wizard-card-footer{
        justify-content: center !important;
    }
    .vue-form-wizard .wizard-tab-content{
        padding: 0px !important;
        width: 100%;
    }
}
</style>